<template>
  <ul class="pagination" v-if="totalPages > 1">
    <li :class="{ disabled: currentPage === 1 }">
      <a @click="prevPage">
        <i class="material-icons">chevron_left</i>
      </a>
    </li>
    <li
      v-for="page in blocks[currentLinks()]"
      :class="[currentPage == page ? 'active' : 'waves-effect']"
      :key="page"
    >
      <a @click="changePage(page)">{{ page }}</a>
    </li>
    <li class="waves-effect" :class="{ disabled: currentPage === totalPages }">
      <a @click="nextPage">
        <i class="material-icons">chevron_right</i>
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  name: "Pagination",
  data() {
    return {
      blocks: []
    };
  },
  props: {
    totalPages: {
      type: Number,
      required: true,
      note: "Total de paginas"
    },
    amountLinks: {
      type: Number,
      default: 4
    },
    currentPage: {
      type: Number,
      default: 1
    }
  },
  mounted() {
    this.getBlocks();
  },
  watch: {
    totalPages() {
      this.getBlocks(this.totalPages);
    }
  },
  methods: {
    getBlocks(totalPage) {
      const totalPages = totalPage || this.totalPages;
      let links = [];
      for (let i = 1; i <= totalPages; i += 1) {
        links.push(i);
        if (links.length === this.amountLinks) {
          this.blocks.push(links);
          links = [];
        }
      }
      if (links.length > 0) this.blocks.push(links);
    },
    nextPage() {
      if (this.currentPage !== this.totalPages) {
        this.changePage(this.currentPage + 1);
      }
    },
    prevPage() {
      if (this.currentPage !== 1) this.changePage(this.currentPage - 1);
    },
    currentLinks() {
      let currentLink;
      this.blocks.forEach((element, indice) => {
        const isBlock = element.some(value => value === this.currentPage);
        if (isBlock) currentLink = indice;
      });
      return currentLink;
    },
    changePage(page) {
      this.$emit("changePage", page);
    }
  }
};
</script>

<style lang="scss" scoped></style>
